export const formatNumber = (number: number): string => {
  return new Intl.NumberFormat('de-DE').format(number);
};
